import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('site-navigation')
export class SiteNavigation extends LitElement {
  @property({ type: Boolean })
  private isMenuOpen = false;
  static override styles = css`
    :host {
      display: block;
      /* --accent-colour: #6e90c0; */
    }
    /* Navigation */
    nav {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(10px);
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      z-index: 1000;
    }

    .nav-container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 64px;
    }

    .logo {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      gap: 12px;
      .site-title {
        font-size: 28px;
        color: var(--accent-colour);
        font-family: 'helvetica serif';
      }
      .site-subtitle {
        font-size: 18px;
        color: var(--accent-colour);
        font-family: 'helvetica serif';
        display: none; // disable for more space on mobile
      }
    }

    .nav-links {
      display: flex;
      gap: 32px;
    }

    .nav-links a {
      color: #374151;
      text-decoration: none;
      transition: color 0.3s;
      font-family: 'helvetica serif';
      color: var(--accent-colour);
    }

    .nav-links a:hover {
      color: var(--accent-colour);
    }

    .menu-btn {
      display: none;
      background: none;
      border: none;
      cursor: pointer;
      flex-direction: column;
      gap: 4px;
    }

    .menu-btn span {
      width: 24px;
      height: 2px;
      background: var(--accent-colour);
    }

    .mobile-menu {
      display: none;
      background: white;
      border-top: 1px solid #e5e7eb;
    }

    .mobile-menu.open {
      display: block;
    }

    .mobile-menu a {
      display: block;
      padding: 12px 20px;
      color: #374151;
      text-decoration: none;
      font-family: 'helvetica serif';
      color: var(--accent-colour);
    }

    .mobile-menu a:hover {
      background: #fef3c7;
    }

    /* Responsive */
    @media (min-width: 768px) {
      .menu-btn {
        display: none;
      }
    }

    @media (max-width: 767px) {
      .nav-links {
        display: none;
      }

      .menu-btn {
        display: flex;
      }
    }

    @media (max-width: 767px) {
      // mobile font size
      .nav-container {
        max-width: 100%;
        padding: 0 10px;
      }
      .logo .site-title {
        font-size: 20px;
      }
      .logo .site-subtitle {
        font-size: 14px;
      }
    }
    @media (min-width: 1024px) {
      .logo .site-subtitle {
        display: block;
      }
    }
  `;

  private toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  scrollToTarget(id: string, event?: Event) {
    // 1. Prevent the browser from reloading the page
    if (event) {
      event.preventDefault();
    }

    // 2. Update the URL in the address bar quietly
    window.history.pushState({}, '', `/${id}`);

    // 3. Trigger your existing scroll logic
    this.dispatchEvent(
      new CustomEvent('scroll-to', {
        detail: { id },
        bubbles: true,
        composed: true,
      }),
    );
  }

  override render() {
    return html`
      <!-- Navigation -->
      <nav>
        <div class="nav-container">
          <div class="logo">
            <span class="site-title">Dance Figures Art</span>
            <span class="site-subtitle">Conceptual Figurative Painting</span>
          </div>
          <div class="nav-links">
            <a href="/">Home</a>
            <a href="/held-by-the-wind" @click=${(e: Event) => this.scrollToTarget('held-by-the-wind', e)}> Held by the Wind </a>
            <a href="/moved-by-the-tide" @click=${(e: Event) => this.scrollToTarget('moved-by-the-tide', e)}>Moved by the Tide</a>
            <a href="/song-of-the-swaying-dunes-i" @click=${(e: Event) => this.scrollToTarget('song-of-the-swaying-dunes-i', e)}>Dunes I</a>
            <a href="/song-of-the-swaying-dunes-ii" @click=${(e: Event) => this.scrollToTarget('song-of-the-swaying-dunes-ii', e)}>Dunes II</a>
          </div>
          <button
            class="menu-btn"
            @click=${this.toggleMenu}
            aria-label="${this.isMenuOpen ? 'Close menu' : 'Open menu'}"
            aria-expanded="${this.isMenuOpen}"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div class="mobile-menu ${this.isMenuOpen ? 'open' : ''}">
          <a href="/">Home</a>
          <a href="/held-by-the-wind" @click=${(e: Event) => this.scrollToTarget('held-by-the-wind', e)}>Held by the Wind</a>
          <a href="/moved-by-the-tide" @click=${(e: Event) => this.scrollToTarget('moved-by-the-tide', e)}>Moved by the Tide</a>
          <a href="/song-of-the-swaying-dunes-i" @click=${(e: Event) => this.scrollToTarget('song-of-the-swaying-dunes-i', e)}>Dunes I</a>
          <a href="/song-of-the-swaying-dunes-ii" @click=${(e: Event) => this.scrollToTarget('song-of-the-swaying-dunes-ii', e)}>Dunes II</a>
        </div>
      </nav>
    `;
  }
}
